import { render } from "./DefaultEndingScreen.vue?vue&type=template&id=1186c4b4&bindings={\"title\":\"data\",\"subtitle\":\"data\",\"picture\":\"data\"}"
import script from "./DefaultEndingScreen.vue?vue&type=script&lang=js"
export * from "./DefaultEndingScreen.vue?vue&type=script&lang=js"

import "./DefaultEndingScreen.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script